export function ChangeData(data){
    return{
        type: 'ChangeData',
        info: "ChangeData",
        payload: {data: data}
    }
}

export function ChangeEdit (allowEdit){
    return{
        type: 'ChangeEdit',
        info: "ChangeEdit",
        payload: {allowEdit: allowEdit}
    }
}

export function ChangeLayout(id, name){
    return{
        type: 'ChangeLayout',
        info: "ChangeLayout",
        payload: {id: id, name: name}
    }
}

export function ChangeLayoutsList(layoutsList){
    return{
        type: 'ChangeLayoutsList',
        info: "ChangeLayoutsList",
        payload: {layoutsList: layoutsList}
    }
}

export function ChangeEquipamentList (EquipamentList){
    return{
        type: 'ChangeEquipamentList',
        info: "ChangeEquipamentList",
        payload: {Equipaments: EquipamentList}
    }
}

export function ChangeLoading (loading){
    return{
        type: 'ChangeLoading',
        info: "ChangeLoading",
        payload: {loading: loading}
    }
}

export function ChangeControlShowCaption(showCaption){
    return{
        type: 'ChangeControlShowCaption',
        info: "ChangeControlShowCaption",
        payload: {showCaption: showCaption}
    }
}

export function ChangeComand (comands){
    return{
        type: 'ChangeComand',
        info: "ChangeComand",
        payload: {comands: comands}
    }
}

export function ChangeModalCode (ModalCode){
    return{
        type: 'ChangeModalCode',
        info: "ChangeModalCode",
        payload: {activeModalCode: ModalCode}
    }
}

export function sendingCode (sendingCode){
    return{
        type: 'sendingCode',
        info: "sendingCode",
        payload: {sendingCode: sendingCode}
    }
}

export function ChangeLastUpdate (lastUpdate){
    return{
        type: 'ChangeLastUpdate',
        info: "ChangeLastUpdate",
        payload: {lastUpdate: lastUpdate}
    }
}

export function ChangeModalComands (activeModalComands){
    return{
        type: 'ChangeModalComands',
        info: "ChangeModalComands",
        payload: {activeModalComands: activeModalComands}
    }
}

export function ChangeAlarms (alarms){
    return{
        type: 'ChangeAlarms',
        info: "ChangeAlarms",
        payload: {alarms: alarms}
    }
}

export function ChangeModalAlarms (activeModalAlarms){
    return{
        type: 'ChangeModalAlarms',
        info: "ChangeModalAlarms",
        payload: {activeModalAlarms: activeModalAlarms}
    }
}

export function showDetails (IsGeral){
    return{
        type: 'showDetails',
        info: "showDetails",
        payload: {IsGeral: IsGeral}
    }
}

export function ChangeCards (cards){
    return{
        type: 'ChangeCards',
        info: "ChangeCards",
        payload: {cards: cards}
    }
}

export function ChangeGraphData (GraphData){
    return{
        type: 'ChangeGraphData',
        info: "ChangeGraphData",
        payload: {GraphData: GraphData}
    }
}

export function ChangeTime (time){
    return{
        type: 'ChangeTime',
        info: "ChangeTime",
        payload: {time: time}
    }
}

export function ChangeControlCities (cities){
    return{
        type: 'ChangeControlCities',
        info: "ChangeControlCities",
        payload: {cities: cities}
    }
}

export function ChangeControlCity (city){
    return{
        type: 'ChangeControlCity',
        info: "ChangeControlCity",
        payload: {city: city}
    }
}

export function ChangeControlTourActive (isTuorActive){
    return{
        type: "ChangeControlTourActive",
        info: "ChangeControlTourActive",
        payload: { isTuorActive: isTuorActive }
    }
}